import { render, staticRenderFns } from "./ChangeSucces.vue?vue&type=template&id=5baff679&scoped=true&"
import script from "./ChangeSucces.vue?vue&type=script&lang=js&"
export * from "./ChangeSucces.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSucces.vue?vue&type=style&index=0&id=5baff679&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baff679",
  null
  
)

export default component.exports